import Cliser from 'cliser';
import Config from 'config';
import {analyzeImage} from '@smartvatten/flowone-algorithms';
import {findDigitsFromFile} from '@smartvatten/flowone-find-digits';
import Utils from 'utils';
import clone from 'clone';

export default class ImageModel extends Cliser.Model {

  properties() {
    return {
      source:     null,         // Valid values: "database", "stream"
      image:      null,         // Image object
      imageData:  null,
      imageSrc:   null,         // Image source URL (string)
      timestamp:  null,         // Image timestamp (ISO string)
      analysis:   null          // Analysis result object
    };
  }

  static getImageData() {
    return this.imageData;
  }

  static setSource(source) {
    this.source = source;
    return this.refresh();
  }

  static refresh() {
    this.image = null;
    this.imageSrc = null;
    this.timestamp = null;

    const loadImage = () => {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.onload = () => {
          this.image = image;
          resolve({
            image,
            src: this.imageSrc
          });
        };
        image.src = this.imageSrc;
      });
    }

    if (this.source === 'database') {
      return Cliser.ConfigModel.latestData()
        .then((data) => {
          if (!data) {
            throw new Error('No image found in database');
          }
          const image = data;
          this.imageSrc = Config.servers.data + '/file/' + image.token;
          this.timestamp = image.timestamp;
          return loadImage();
        });

    }

    if (this.source === 'stream') {
      return Cliser.ConfigModel.getSettings()
        .then((settings) => Cliser.DeviceModel.takeCustomPhoto(settings.camera, settings.orientation))
        .then((photo) => {
          this.imageData = photo.imageData;
          this.imageSrc = photo.src;
          this.timestamp = (new Date()).toISOString();
          return loadImage();
        });
    }

    throw ("Invalid source: " + this.source);
  }

  static autoConfig() {
    if (!this.imageSrc) {
      throw new Error('Image source not set');
    }

    return new Promise((resolve, reject) => {
      findDigitsFromFile(this.imageSrc).then((res) => {
        console.log('find digits result', res);
        return resolve(res);
      }).catch((err) => {
        reject(err);
      });
    })
  }

  static analyze(settings) {
    if (!this.imageSrc) {
      throw new Error('Image source not set');
    }

    this.analysis = null;
    return Cliser.ConfigModel.getState()
      .then((state) => {
        return new Promise((resolve, reject) => {

          var clonedSettings = clone(settings);
          // force digits analyze if digit are enabled
          if (clonedSettings.digits.enabled) {
            clonedSettings.analyzeDigits = true;
            clonedSettings.digits.debugImage = true;
          }
          analyzeImage(
            this.imageSrc,
            clonedSettings,
            (err, result) => {
              if (err) {
                reject(err);
              } else {
                //console.log("result", result);
                if(result.pointers) console.log(result.pointers.debug);
                var digitIntegerRawValue = null;
                var digitDecimalRawValue = null;
                var digitHeight = null;
                var integerDigitHeights = null;
                var decimalDigitHeights = null;
                var integerDigitWidths = null;
                var decimalDigitWidths = null;
                var debugData = null;

                if (result && result.pointers) {
                  var vectorDistances = [];
                  var edgePoints = [];
                  for(var i in result.pointers.meters) {
                    vectorDistances.push(Math.round(result.pointers.meters[i].distance))
                    edgePoints.push(result.pointers.meters[i].edgePoints)
                  }
                  if(Array.isArray(vectorDistances)) vectorDistances = vectorDistances.join(',  ');
                  if(Array.isArray(edgePoints)) edgePoints = edgePoints.join(',  ');
                }
                if (result && result.digits) {
                  console.log(result.digits.integer);
                  if(result.digits.integer) {
                    digitIntegerRawValue = result.digits.integer.rawValue;
                    if(Array.isArray(digitIntegerRawValue)) digitIntegerRawValue = digitIntegerRawValue.join(',  ');
                  }
                  if(result.digits.decimal) {
                    digitDecimalRawValue = result.digits.decimal.rawValue;
                    if(Array.isArray(digitDecimalRawValue)) digitDecimalRawValue = digitDecimalRawValue.join(',  ');
                  }
                  if(result.digits.height) {
                    digitHeight = result.digits.height;
                  }
                  if(result.digits.integerDigitHeights) {
                    integerDigitHeights = result.digits.integerDigitHeights;
                    if(Array.isArray(integerDigitHeights)) integerDigitHeights = integerDigitHeights.join(',  ');
                  }
                  if(result.digits.decimalDigitHeights) {
                    decimalDigitHeights = result.digits.decimalDigitHeights;
                    if(Array.isArray(decimalDigitHeights)) decimalDigitHeights = decimalDigitHeights.join(',  ');
                  }

                  if(result.digits.integerDigitWidths) {
                    integerDigitWidths = result.digits.integerDigitWidths;
                    if(Array.isArray(integerDigitWidths)) integerDigitWidths = integerDigitWidths.join(',  ');
                  }
                  if(result.digits.decimalDigitWidths) {
                    decimalDigitWidths = result.digits.decimalDigitWidths;
                    if(Array.isArray(decimalDigitWidths)) decimalDigitWidths = decimalDigitWidths.join(',  ');
                  }
                  if(result.digits.data) {
                    debugData = result.digits.data;
                  }
                }

                let analysis = {
                  ...result,
                  digitIntegerRawValue,
                  digitDecimalRawValue,
                  integerDigitHeights,
                  decimalDigitHeights,
                  integerDigitWidths,
                  decimalDigitWidths,
                  debugData,
                  timestamp: this.timestamp,
                  source: this.source,
                  edgePoints,
                  vectorDistances
                };

                //if (analysis.pointers && analysis.pointers.canvas) {
                //  this.analysis = analysis;
                //  resolve(analysis);
                //} else {
                  Utils.createCanvasImage(this.imageSrc).then((canvas) => {
                    analysis.canvas = canvas;
                    //analysis.imageBase64 = canvas.toDataURL();
                    this.analysis = analysis;
                    resolve(analysis);
                  });
                //}
              }
            }
          );
        });
      });
  }
}



// WEBPACK FOOTER //
// ./client/models/ImageModel.js